import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';
import { pxeBackendApi } from './slices/pxeBackendApiSlice';
import { solarQuoteSlice } from './slices/solarQuoteSlice';

const rootReducer = combineReducers({
  [pxeBackendApi.reducerPath]: pxeBackendApi.reducer,
  [solarQuoteSlice.reducerPath]: solarQuoteSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export const makeStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    devTools:
      process.env.NODE_ENV === 'production' ? false : { name: 'redux-store' },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(pxeBackendApi.middleware),
    preloadedState,
  });

// Infer the type of `store`
export type ReduxAppStore = ReturnType<typeof makeStore>;
// Infer the `AppDispatch` type from the store itself
export type ReduxAppDispatch = ReduxAppStore['dispatch'];

export const useReduxAppDispatch = () => useDispatch<ReduxAppDispatch>();
export const useReduxAppSelector: TypedUseSelectorHook<RootState> = useSelector;
